import * as types from '../action_types'
import * as bkg_actn_types from './action_types'

export const NewRowData = {
  description: '',
  pack_method: '',
  unit: '0',
  goods_value: '0',
  goods_value2: '0',
  wt_actual: '0',
  wt_volume: '0',
  wt_charge: '0',
  rate: '0',
  rate2: '0',
  freight: '0',
  freight2: '0',
  wt_vlm_len: '',
  wt_vlm_wid: '',
  wt_vlm_ht: '',
  unitType: 'FEET',
  action: '',
  slctdCnsgnmntType: {},
  slctdMethodOfPckgType: {},
}
export const InitialPriceSectionData = {
  freight: '0',
  DiscOnFreight: '',
  coll_cartage: '',
  coll_cartage2: '',
  del_cartage: '',
  del_cartage2: '',
  hamali: '',
  hamali3: '',
  op_hamali: '',
  op_hamali3: '',
  valuation: '',
  valuation2: '',
  doc_fee: '',
  doc_fee2: '',
  pickup_fee: '',
  pickup_fee2: '',
  dropoff_fee: '',
  dropoff_fee2: '',
  gst: '',
  CCBrkup_pckp: '',
  CCBrkup_cmsn: '',
  CCBrkup_rtrn: '',
  gross_amount: 0,
  addiTionalChrg: '',
}
export const STANewRowData = { ...NewRowData, unitType: 'INCH' }
const initialState = {
  loader: true,
  data: {},
  consignmntData: [NewRowData],
  priceSectionData:{...InitialPriceSectionData} ,
  rateWisePriceData: {},
  InsuranceCharges: 0,
  documentChargesList: {},
  cargoBookingResponse: {},
  cargoprintData: {},
  cargoReprintData: {},
  nearestStates: [],
  nearestCities: [],
  nearestBranches: [],
  selectedNearestBranch: '',
}

const bookingReducer = function (state = initialState, action) {
  let stateL = { ...state }
  let consignmntDataL = JSON.parse(JSON.stringify(stateL.consignmntData))
  const { data, type } = { ...action }
  switch (type) {
    case types.LOADER:
      return {
        ...state,
        loader: data,
      }
    case types.UPDATE_DETAILS:
      stateL[action.sectName][action.key] = action.value
      return Object.assign({}, state, {
        stateL,
      })
    case bkg_actn_types.ADD_NEW_CONSIGNMENT_ROW:
      consignmntDataL.push({ ...NewRowData })
      return Object.assign({}, state, {
        consignmntData: consignmntDataL,
      })
    case bkg_actn_types.REMOVE_CONSIGNMENT_ROW:
      consignmntDataL.splice(action.index, 1)
      return Object.assign({}, state, {
        consignmntData: consignmntDataL,
      })
    case bkg_actn_types.PRICE_SECTION_DATA:
      let priceSectionDataL = { ...stateL.priceSectionData }
      priceSectionDataL[action.key] = data
      return Object.assign({}, state, {
        priceSectionData: priceSectionDataL,
      })
    case bkg_actn_types.RATE_WISE_PRICE_DATA:
      return { ...state, rateWisePriceData: { ...state.rateWisePriceData, ...action.data }, InsuranceCharges: action.data2 }
    case bkg_actn_types.RATE_WISE_PRICE_DATA_REMOVE: {
      const { [action.data]: _, ...rest } = state.rateWisePriceData // Remove the specific key
      const reIndexedRateWisePriceData = Object.fromEntries(
        Object.entries(rest).map(([key, value], index) => [index, value]) // Re-index keys
      )
      return { ...state, rateWisePriceData: reIndexedRateWisePriceData }
    }
    case bkg_actn_types.CONSGMNT_SECTION_DATA: {
      const newData = parseFloat(data)
      if (!isNaN(newData)) {
        const decimalPlaces = (newData.toString().split('.')[1] || '').length
        const roundedData = decimalPlaces > 1 ? newData.toFixed(2) : newData
        consignmntDataL[action.param][action.key] = roundedData
      } else {
        consignmntDataL[action.param][action.key] = data
      }
      return { ...state, consignmntData: consignmntDataL }
    }
    case bkg_actn_types.CONSIGNMENT_ROW:
      consignmntDataL[action.param] = { ...data }
      return { ...state, consignmntData: consignmntDataL }
    case bkg_actn_types.PRICE_SECTION_ROW:
      return { ...state, priceSectionData: { ...data } }
    case bkg_actn_types.DOCUMENT_CHARGE_LIST:
      return {
        ...state,
        documentChargesList: { ...data },
      }
    case bkg_actn_types.BOOK_CARGO:
      return {
        ...state,
        cargoBookingResponse: data,
      }
    case bkg_actn_types.CARGO_PRINT_DATA:
      return {
        ...state,
        cargoprintData: data,
      }
    case bkg_actn_types.CARGO_REPRINT_DATA:
      return {
        ...state,
        cargoReprintData: data,
      }
    case bkg_actn_types.NEAREST_STATES:
      return {
        ...state,
        nearestStates: action.data,
      }
    case bkg_actn_types.NEAREST_CITIES:
      return {
        ...state,
        nearestCities: action.data,
      }
    case bkg_actn_types.NEAREST_BRANCH:
      return {
        ...state,
        nearestBranches: action.data,
      }
    case bkg_actn_types.SELECTED_NEAREST_BRANCH:
      return {
        ...state,
        selectedNearestBranch: action.data,
      }

    default:
      return state
  }
}

export default bookingReducer
